export default "__VITE_PUBLIC_ASSET__b3e07beb__"